<!--
 * @Author: ke.xue
 * @Date: 2021-12-17 11:24:06
 * @LastEditors: ke.xue
 * @LastEditTime: 2022-01-18 15:10:19
 * @FilePath: \qw-scrm-h5\components\clue\checkbox.vue
 * @Description: 自定义多选组件
-->
<template>
  <div class="clueCheckbox formBox">
    <h3 :class="['formLabel', { formRequired: formJson.required }]">{{ formJson.screenKey }}</h3>
    <div class="screenValueBox">
      <div
        v-for="(item, index) in screenValue"
        :key="index"
        class="screenValueItem pointer"
        :class="[{active: currentObj[item[valueKey]]}]"
        @click="onChange(item)"
      >{{ item[labelKey] }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClueCheckbox',
  model: {
    prop: 'defaultValue',
    event: 'change'
  },
  props: {
    formJson: {
      type: Object,
      required: true,
      default: () => ({})
    },
    defaultValue: {
      type: [Array, Object],
      default: () => ([])
    }
  },
  data() {
    return {
      screenValue: [],
      valueKey: 'code',
      labelKey: 'name',
      currentObj: {}
    }
  },
  watch: {
    'formJson.screenValue': {
      deep: true,
      immediate: true,
      handler(nVal) {
        this.init()
        this.screenValue = nVal
        const activeObj = {}
        const { defaultValue, valueKey } = this
        if (defaultValue.length) {
          nVal.map(item => {
            const code = String(item[valueKey])
            defaultValue.includes(code) && (activeObj[code] = item)
          })
        }
        this.currentObj = activeObj
      }
    },
    defaultValue(val) {
      if (val.length === 0) {
        this.currentObj = {}
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const { valueKey, labelKey } = this.formJson
      valueKey && (this.valueKey = valueKey)
      labelKey && (this.labelKey = labelKey)
    },
    onChange(item) {
      const { valueKey, currentObj } = this
      const code = item[valueKey]
      if (currentObj[code]) {
        this.$delete(this.currentObj, code)
      }
      else {
        this.$set(this.currentObj, code, item)
      }
      const active = Object.keys(this.currentObj)
      this.$emit('change', active)
    }
  }
}
</script>

<style lang="less" scoped>
.clueCheckbox {
  .screenValueBox {
    .screenValueItem {
      border-radius: 2px;
    }
  }
}
</style>
